import { A11yModule } from '@angular/cdk/a11y';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { OptionComponent } from './option.component';
import {
  SELECT_SCROLL_STRATEGY_PROVIDER,
  SelectComponent,
} from './select.component';

const COMPONENTS = [SelectComponent, OptionComponent];

@NgModule({
  imports: [
    CommonModule,
    A11yModule,
    OverlayModule,
    PortalModule,
    SharedModule,
  ],
  declarations: COMPONENTS,
  exports: COMPONENTS,
  providers: [SELECT_SCROLL_STRATEGY_PROVIDER],
})
export class SelectModule {}
